/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface AgrementSearch
 */
export interface AgrementSearch {
    /**
     * 
     * @type {number}
     * @memberof AgrementSearch
     */
    idApprenant?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgrementSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof AgrementSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof AgrementSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgrementSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof AgrementSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AgrementSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the AgrementSearch interface.
 */
export function instanceOfAgrementSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AgrementSearchFromJSON(json: any): AgrementSearch {
    return AgrementSearchFromJSONTyped(json, false);
}

export function AgrementSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgrementSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idApprenant': !exists(json, 'idApprenant') ? undefined : json['idApprenant'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function AgrementSearchToJSON(value?: AgrementSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idApprenant': value.idApprenant,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

